@if (dashboardData) {
  <div class="p-3 pt-2 rounded-4">
    <div>
      <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 text-center p-0">
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('transactions')"
          [ngClass]="isActive('transactions') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-database-fill"></i>
          Transactions
        </button>
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('disputes')"
          [ngClass]="isActive('disputes') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-bug-fill"></i>
          Disputes
        </button>
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('risk')"
          [ngClass]="isActive('risk') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-shield-fill"></i>
          Risk
        </button>
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('ops')"
          [ngClass]="isActive('ops') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-gear-fill"></i>
          OPS
        </button>
      </div>
    </div>
    <div class="container-fluid mb-3 date-filter-wrapper">
      <app-date-filter [fromDate]="selectedFromDate" [toDate]="selectedToDate"
      (dateSelected)="onDateSelected($event)"></app-date-filter>
    </div>
    <div class="container-fluid">
      <!-- MFA Prompt -->
      <app-mfa-prompt></app-mfa-prompt>
      @if (isActive('transactions')) {
        <div class="row bg-white p-2 pt-0">
          <div class="col">
            <div class="card card-total rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-primary border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.total}}</div>
                    <!-- <div>{{dashboardData.totalSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-calculator fs-1 fw-bold mt-n-15px"></i>
                    <div>TOTAL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card card-success rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-success border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.success}}</div>
                    <!-- <div>{{dashboardData.successSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-check fs-1 fw-bold mt-n-15px"></i>
                    <div>SUCCESS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card card-failed rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-danger border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.failed}}</div>
                    <!-- <div>{{dashboardData.failedSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-x fs-1 fw-bold mt-n-15px"></i>
                    <div>FAILED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.refund}}</div>
                    <!-- <div>{{dashboardData.refundSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-arrow-counterclockwise fs-1 fw-bold mt-n-15px"></i>
                    <div>REFUND</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card card-pending rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-info border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.pending}}</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-hourglass-split fs-1 fw-bold mt-n-15px"></i>
                    <div>PENDING</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100"></div>
          <div class="col-md-8">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Country Wise Spending</p>
              @if (!barChartSettings.data?.length) {
                <div class="text-center py-4">
                  <p class="text-muted">No spending data available</p>
                </div>
              }
              @if (barChartSettings.data?.length) {
              <div class="">
                <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="barChartSettings.data"
                  [gradient]="barChartSettings.gradient" [barPadding]="40"
                  [xAxis]="barChartSettings.showXAxis" [yAxis]="barChartSettings.showYAxis"
                  [legend]="barChartSettings.showLegend" [showXAxisLabel]="barChartSettings.showXAxisLabel"
                  [showYAxisLabel]="barChartSettings.showYAxisLabel"
                  [xAxisLabel]="barChartSettings.xAxisLabel" [yAxisLabel]="barChartSettings.yAxisLabel"
                  (select)="onDisputeSelect($event)">
                </ngx-charts-bar-vertical>
              </div>
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Number of Transactions</p>
              @if (!transactionsPieChart.data?.length) {
                <div class="text-center py-4">
                  <p class="text-muted">No transaction data available</p>
                </div>
              }
              @if (transactionsPieChart.data?.length) {
              <div class="">
                <ngx-charts-bar-horizontal [scheme]="colorScheme" [results]="transactionsPieChart.data"
                  [gradient]="disputesPieChartSettings.gradient"
                  [xAxis]="true" [yAxis]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                  [xAxisLabel]="'Count'" [yAxisLabel]="'Country'">
                </ngx-charts-bar-horizontal>
              </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isActive('disputes')) {
        <div class="row bg-light p-2 pt-0 rounded-3">
          @if (!disputesData || !disputesData.total) {
            <div class="text-center py-5">
              <i class="bi bi-inbox fs-1 text-muted"></i>
              <p class="text-muted mt-2">No dispute data available</p>
            </div>
          }
          @if (disputesData && disputesData.total) {
          <div class="col-md-3">
            <div class="card card-total rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-primary border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{disputesData.open}}</div>
                    <div>{{(disputesData.open / disputesData.total)*100 | number : '1.2-2'}} %</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                    <div>OPEN</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{disputesData.inProgress}}</div>
                    <div>{{(disputesData.inProgress / disputesData.total)*100 | number : '1.2-2'}} %</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                    <div>IN-PROGRESS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-failed rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-danger border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{disputesData.rejected}}</div>
                    <div>{{(disputesData.rejected / disputesData.total)*100 | number : '1.2-2'}} %</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                    <div>REJECTED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{disputesData.refunded}}</div>
                    <div>{{(disputesData.refunded / disputesData.total)*100 | number : '1.2-2'}} %</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                    <div>REFUNDED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-success rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-success border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{disputesData.resolved}}</div>
                    <div>{{(disputesData.resolved / disputesData.total)*100 | number : '1.2-2'}} %</div>
                  </div>
                  <div class="text-center">
                    <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                    <div>RESOLVED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          <div class="col-md-8">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Country Wise Disputes</p>
              @if (!disputesData || !disputesLineChartData[0]?.series?.length) {
                <div class="text-center py-4">
                  <p class="text-muted">No country-wise data available</p>
                </div>
              }
              @if (disputesData && disputesLineChartData[0]?.series?.length) {
              <div class="">
                <ngx-charts-line-chart [scheme]="colorScheme" [results]="disputesLineChartData"
                  [gradient]="barChartSettings.gradient" [xAxis]="barChartSettings.showXAxis"
                  [yAxis]="barChartSettings.showYAxis" [legend]="barChartSettings.showLegend"
                  [showXAxisLabel]="barChartSettings.showXAxisLabel"
                  [showYAxisLabel]="barChartSettings.showYAxisLabel"
                  [xAxisLabel]="barChartSettings.xAxisLabel" [yAxisLabel]="'Count'"
                  (select)="onDisputeSelect($event)">
                </ngx-charts-line-chart>
              </div>
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Summary</p>
              @if (!disputesData || !disputesData.total) {
                <div class="text-center py-4">
                  <p class="text-muted">No summary data available</p>
                </div>
              }
              @if (disputesData && disputesData.total) {
              <div class="">
                <ngx-charts-bar-horizontal [scheme]="colorScheme" [results]="disputesChartData"
                  [gradient]="disputesPieChartSettings.gradient"
                  [xAxis]="true" [yAxis]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                  [xAxisLabel]="'Count'" [yAxisLabel]="''">
                </ngx-charts-bar-horizontal>
              </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isActive('risk')) {
        <div class="row bg-light p-2 pt-0 rounded-3">
          <app-risk></app-risk>
        </div>
      }
      @if (isActive('ops')) {
        <div class="row bg-light p-2 pt-0 rounded-3">
          <app-ops></app-ops>
        </div>
      }
    </div>
  </div>
}